export const SET_FREIGHT_COLLECTION = 'FREIGHT/SET_FREIGHT_COLLECTION';
